import { Link } from 'react-router-dom';

/**
 * Painel inicial.
 *
 * Cartão com `rota` é módulo pronto e vira atalho; sem `rota` é escopo acordado
 * que ainda não existe. A diferença precisa estar visível na tela — sem ela o
 * cliente clica no que não abre e conclui que o painel está quebrado.
 */
const MODULES = [
  { name: 'Banner', description: 'Título, vídeo e chamada do topo', rota: '/banner' },
  {
    name: 'Ateliê',
    description: 'História, números e fotos da marcenaria',
    rota: '/atelie',
  },
  { name: 'Ambientes', description: 'Lista de ambientes atendidos', rota: '/ambientes' },
  {
    name: 'Projetos',
    description: 'Galeria de obras entregues e suas imagens',
    rota: '/projetos',
  },
  { name: 'Bastidores', description: 'Vídeo e capa da seção de bastidores' },
  { name: 'Processo', description: 'Etapas do atendimento', rota: '/processo' },
  { name: 'Depoimento', description: 'A fala de cliente entre as seções', rota: '/depoimento' },
  {
    name: 'Showroom',
    description: 'Textos e foto da seção de visita',
    rota: '/showroom',
  },
  { name: 'Leads', description: 'Pedidos de orçamento recebidos' },
  {
    name: 'Empresa',
    description: 'Contatos, WhatsApp e redes sociais',
    rota: '/empresa',
  },
  { name: 'SEO', description: 'Títulos, descrições e imagem de compartilhamento' },
  { name: 'Usuários', description: 'Contas com acesso ao painel', rota: '/usuarios' },
] as const;

export function DashboardPage() {
  return (
    <div>
      <p className="text-xs tracking-[0.18em] text-brass uppercase">Visão geral</p>
      <h1 className="mt-2 font-display text-3xl">Módulos do painel</h1>

      <p className="mt-4 max-w-[60ch] text-sm text-ink-soft">
        Os módulos em destaque já podem ser editados. Os demais entram por fase.
      </p>

      <ul className="mt-8 grid gap-px border border-sand bg-sand sm:grid-cols-2 lg:grid-cols-3">
        {MODULES.map((item) => (
          <li key={item.name} className="bg-bone p-5">
            {'rota' in item ? (
              <Link to={item.rota} className="group block">
                <h2 className="font-display text-lg text-brand-700 underline-offset-4 group-hover:underline">
                  {item.name}
                </h2>
                <p className="mt-1 text-sm text-ink-soft">{item.description}</p>
              </Link>
            ) : (
              <>
                <h2 className="font-display text-lg text-ink-soft">{item.name}</h2>
                <p className="mt-1 text-sm text-ink-soft/70">{item.description}</p>
                <p className="mt-2 text-xs tracking-[0.12em] text-ink-soft/60 uppercase">
                  ainda não implementado
                </p>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
